import type { components as OpenAPI } from "@/autogen/internal-openapi";
import { unique } from "@/lib/collections";
import PRICES from "@/autogen/prices-v2.json";
import PRICES_V3 from "@/autogen/prices-v3.json";
import type { Account } from "@/types/account";

type Invoice = OpenAPI["schemas"]["Invoice"];
export type InvoiceWithId = Invoice & { id: string };

export const FEATURE_IDS: (typeof PRICES)[number]["features"] = unique(
  PRICES.map((feature) => feature.features).flat()
);
export type Feature = (typeof FEATURE_IDS)[number];

type PricingTier = (typeof PRICES)[number];

const minimumPlan = (feature: Feature): PricingTier | null => {
  const tier = PRICES.find((t) => t.features.includes(feature));
  if (!tier) {
    return null;
  }
  return tier;
};

export function requiredPlan(
  account: Account,
  feature: Feature
): Pick<PricingTier, "id" | "name" | "url"> | null {
  if (account.billing_type === "GIFT") {
    return null;
  }
  if (account.billing_type === "VOLUME_BASED") {
    return null;
  }
  if (account.billing_type === "V2") {
    if (account.features.includes(feature)) {
      return null;
    }
    const minimum = minimumPlan(feature);
    if (minimum && minimum.id === account.billing_plan) {
      return null;
    }
    return minimum;
  }
  if (account.billing_type === "V3") {
    if (account.features.includes(feature)) {
      return null;
    }
    const minimum = PRICES_V3.find((t) => t.features.includes(feature));
    if (!minimum) {
      return null;
    }
    if (minimum.id === account.billing_plan) {
      return null;
    }
    return minimum;
  }
  return null;
}
